/** An oRPC list page (`items`, `partial`, `nextCursor`) in the shape `useCursorPagination` pages over. */
export function toCursorPage<TItem>(page: {
  items: readonly TItem[]
  partial: boolean
  nextCursor: string | null
}) {
  return {
    items: page.items,
    partial: page.partial,
    pageInfo: { hasNextPage: page.nextCursor !== null, endCursor: page.nextCursor }
  }
}
